var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { useAnimationClassName } from "../../../hooks/useAnimationClassName";
import { Typography } from "antd";
var AgendaTitle = function (_a) {
    var children = _a.children, baseClass = _a.baseClass, animation = _a.animation, _b = _a.titleLevel, titleLevel = _b === void 0 ? 2 : _b;
    var titleRef = useRef(null);
    var titleAnimationClass = useAnimationClassName({ ref: titleRef, animation: animation });
    return (_jsx(Typography.Title, __assign({ ref: titleRef, style: { marginBottom: 20 }, className: "".concat(baseClass, "__title ").concat(titleAnimationClass), level: titleLevel }, { children: children })));
};
export default AgendaTitle;
